import { CommonService } from '../common/common.service';
import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
	UrlTree,
	NavigationEnd,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { AdPolicyService } from '../ad-policy/ad-policy.service';
import { DurationCounterService } from 'src/app/services/timer/timer-service-ex.service';
import { ConfigService } from '../config/config.service';
import { DeviceService } from '../device/device.service';
import { BatteryDetailService } from '../battery-detail/battery-detail.service';
import { SystemUpdatePresenterService } from 'src/app/presenters/user-cases/system-update/system-update-presenter';

@Injectable({
	providedIn: 'root',
})
export class GuardService {
	interTime = 0;
	metrics: any;
	pageContext: any;
	previousPageName = '';
	duration = 0;
	timer = 0;
	activeTime = 0;
	focusDurationCounter = null;
	blurDurationCounter = null;

	constructor(
		private commonService: CommonService,
		private adPolicy: AdPolicyService,
		private configService: ConfigService,
		private timerService: DurationCounterService,
		private deviceService: DeviceService,
		private batteryService: BatteryDetailService,
		private systemUpdatePresenter: SystemUpdatePresenterService
	) {}

	canActivate(
		activatedRouteSnapshot: ActivatedRouteSnapshot,
		routerStateSnapshot: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
		this.focusDurationCounter = this.timerService.getFocusDurationCounter();
		this.blurDurationCounter = this.timerService.getBlurDurationCounter();

		if (
			routerStateSnapshot.url.includes('system-updates') &&
			!this.systemUpdatePresenter.isVisible()
		) {
			return this.commonService.isFirstPageLoaded() ? false : this.configService.defaultRoute;
		}

		if (
			routerStateSnapshot.url.includes('high-density-battery') &&
			this.batteryService.isTemporaryChargeMode
		) {
			return this.batteryService.isDlsPiCapable;
		}

		return true;
	}

	canDeactivate(
		component: object,
		activatedRouteSnapshot: ActivatedRouteSnapshot,
		routerStateSnapshot: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		window.getSelection().empty();
		this.pageContext = activatedRouteSnapshot.data.pageContent;
		if (this.pageContext && this.pageContext.indexOf('[LocalStorageKey]') !== -1) {
			this.pageContext = this.commonService.getLocalStorageValue(this.pageContext);
		}
		const focusDuration =
			this.focusDurationCounter !== null ? this.focusDurationCounter.getDuration() : 0;
		const blurDuration =
			this.blurDurationCounter !== null ? this.blurDurationCounter.getDuration() : 0;

		const data = {
			PageName: activatedRouteSnapshot.data.pageName,
			PageDuration: focusDuration,
			PageDurationBlur: blurDuration,
			PageContext: this.pageContext,
		};
		this.previousPageName = activatedRouteSnapshot.data.pageName;
		return true;
	}
}
